module.exports = __webpack_public_path__ + "static/img/rtf.e535315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/rtf.png
// module id = 2xXi
// module chunks = 53